import { Box, useTheme } from "@outschool/backpack";
import { BASE_LOCALE, useLocale } from "@outschool/localization";
import {
  TrustpilotMicroCombo,
  TrustpilotSlider
} from "@outschool/ui-components-website";
import { Space } from "@outschool/ui-legacy-component-library";
import React from "react";

const TutoringReviews = () => {
  const theme = useTheme();
  const locale = useLocale();

  return (
    <>
      {locale === BASE_LOCALE ? (
        <Box
          sx={{
            backgroundColor: theme.palette.warning[50],
            padding: "5rem 0",
            [theme.breakpoints.down("md")]: {
              margin: "7rem 0"
            },
            [theme.breakpoints.up("md")]: {
              margin: "10rem 0"
            }
          }}
        >
          <Box flex sx={{ justifyContent: "center" }}>
            <TrustpilotMicroCombo
              sx={{
                [theme.breakpoints.down("md")]: {
                  margin: 0
                },
                [theme.breakpoints.up("md")]: {
                  width: "100%"
                }
              }}
              widgetCss={{
                height: "48px"
              }}
            />
          </Box>
          <TrustpilotSlider
            sx={{ height: "180px" }}
            widgetCss={{ height: "180px" }}
            widgetData={{
              tags: "tutoring",
              stars: "4,5",
              "review-languages": "en"
            }}
          />
        </Box>
      ) : (
        <Space y={"10rem"} />
      )}
    </>
  );
};

export default TutoringReviews;
